/* @flow */
import React from 'react';
import BoxTitle from 'components/BoxTitle.jsx';
import Organization from 'entities/Organization';
import TeacherAddManualTabView from './TeacherAddManualTabView.jsx';

const EVENT_SCREEN_NAME = 'TeacherAddUploadTabFixErrors';

class TeacherAddUploadTabFixErrors extends React.Component {
  static propTypes = {
    organization: React.PropTypes.instanceOf(Organization).isRequired,
    users: React.PropTypes.array,
    role: React.PropTypes.string,
    onSuccess: React.PropTypes.func,
  };

  static childContextTypes = {
    eventScreenName: React.PropTypes.string,
  };

  getChildContext() {
    return {
      eventScreenName: EVENT_SCREEN_NAME,
    };
  }

  render() {
    const name = 'We found the following errors';
    return (
      <div>
        <BoxTitle title={name} />
        <TeacherAddManualTabView
          users={this.props.users}
          role={this.props.role}
          organization={this.props.organization}
          onSuccess={this.props.onSuccess}
        />
      </div>
    );
  }
}

export default TeacherAddUploadTabFixErrors;




// WEBPACK FOOTER //
// ./src/groups/components/TeacherAddUploadTabFixErrors.jsx